/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExclusionTerm } from './ExclusionTerm';
import {
    ExclusionTermFromJSON,
    ExclusionTermFromJSONTyped,
    ExclusionTermToJSON,
    ExclusionTermToJSONTyped,
} from './ExclusionTerm';

/**
 * 
 * @export
 * @interface CreateDocumentExclusionTerm201Response
 */
export interface CreateDocumentExclusionTerm201Response {
    /**
     * 
     */
    data?: ExclusionTerm;
}

/**
 * Check if a given object implements the CreateDocumentExclusionTerm201Response interface.
 */
export function instanceOfCreateDocumentExclusionTerm201Response(value: object): value is CreateDocumentExclusionTerm201Response {
    return true;
}

export function CreateDocumentExclusionTerm201ResponseFromJSON(json: any): CreateDocumentExclusionTerm201Response {
    return CreateDocumentExclusionTerm201ResponseFromJSONTyped(json, false);
}

export function CreateDocumentExclusionTerm201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentExclusionTerm201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ExclusionTermFromJSON(json['data']),
    };
}

export function CreateDocumentExclusionTerm201ResponseToJSON(json: any): CreateDocumentExclusionTerm201Response {
    return CreateDocumentExclusionTerm201ResponseToJSONTyped(json, false);
}

export function CreateDocumentExclusionTerm201ResponseToJSONTyped(value?: CreateDocumentExclusionTerm201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ExclusionTermToJSON(value['data']),
    };
}

